import React, { Component } from 'react';

import { Modal, ListGroup, ListGroupItem } from 'react-bootstrap';

// This component is specifically designed to display scheduled updates to
// Ready for Allocation along with the reason for corresponding update
export default class ScheduledAllocationEvents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteModal: false,
      event: {
        prod: {},
        reason: {},
      },
    };
    this.displayDeleteConfirm = this.displayDeleteConfirm.bind(this);
    this.getProdIndices = this.getProdIndices.bind(this);
    this.getReasonIndices = this.getReasonIndices.bind(this);
    this.getSchedulesToDisplay = this.getSchedulesToDisplay.bind(this);
  }

  // When a scheduled update to Ready for Allocation is deleted we should delete 2 scheduled events
  // (1) Delete scheduled change to prod (i.e., allocation value), identified by its uuid and actionTime
  // (2) Delete corresponding scheduled change to update reason, identified by its uuid and actionTime
  // eslint-disable-next-line react/sort-comp
  displayDeleteConfirm(prod, reason) {
    this.setState({
      deleteModal: true,
      event: {
        prod: {
          uuid: prod.uuid,
          actionTime: prod.actionTime,
        },
        reason: {
          uuid: reason.uuid,
          actionTime: reason.actionTime,
        },
      },
    });
  }

  // loop through array of all scheduled events (this.props.events)
  // and find indices that correspond to a change to prod
  getProdIndices(indices) {
    const prodIndices = [];
    for (let i = 0; i < indices.length; i++) {
      if (this.props.events[indices[i]].change.attribute === 'prod') {
        prodIndices.push(indices[i]);
      }
    }
    return prodIndices;
  }

  // loop through array of all scheduled events (this.props.events)
  // and find indices that correspond to a change to updateReason
  getReasonIndices(indices) {
    const reasonIndices = [];
    for (let i = 0; i < indices.length; i++) {
      if (this.props.events[indices[i]].change.attribute === 'updateReason') {
        reasonIndices.push(indices[i]);
      }
    }
    return reasonIndices;
  }

  // for every update to prod scheduled, find its corresponding reason
  // i.e., update to reason with same action time
  // Note: this will not work if multiple updates are scheduled for updateReason at the same time (this is not a very likely use case so ignoring it for now)
  getSchedulesToDisplay(indices) {
    const scheduledEvents = [];
    const prodIndices = this.getProdIndices(indices);
    const reasonIndices = this.getReasonIndices(indices);
    for (let i = 0; i < prodIndices.length; i++) {
      const event = {};
      event.prodIndex = prodIndices[i];
      event.actionTime = this.props.events[prodIndices[i]].actionTime;
      event.uuid = this.props.events[prodIndices[i]].uuid;
      for (let j = 0; j < reasonIndices.length; j++) {
        if (
          this.props.events[reasonIndices[j]].actionTime === event.actionTime
        ) {
          event.reasonIndex = reasonIndices[j];
          break;
        }
      }
      // Display will be <prod value> ; <reason for change>
      event.change = `${this.props.events[event.prodIndex].change.value} ; ${
        this.props.events[event.reasonIndex].change.value.prod
      }`;
      scheduledEvents.push(event);
    }
    return scheduledEvents;
  }

  render() {
    const indices = Object.keys(this.props.events).filter(
      (ind) =>
        this.props.events[ind].change.attribute === 'prod' ||
        this.props.events[ind].change.attribute === 'updateReason',
    );
    const schedulesToDisplay = this.getSchedulesToDisplay(indices);
    return (
      <div>
        <Modal show={this.state.deleteModal}>
          <Modal.Header>
            <Modal.Title>Delete Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to delete this item?</Modal.Body>
          <Modal.Footer>
            &nbsp;
            <button
              onClick={() => this.setState({ deleteModal: false })}
              type="button"
              className="btn modalButtons btn-info"
            >
              Close
            </button>
            <button
              onClick={() => {
                this.setState({ deleteModal: false });
                this.props.deleteScheduleAction(this.state.event);
              }}
              type="button"
              className="btn modalButtons btn-warning"
            >
              Delete
            </button>
          </Modal.Footer>
        </Modal>
        {schedulesToDisplay.length !== 0 && (
          <ListGroup>
            <ListGroupItem header="Scheduled Changes:" />
            {schedulesToDisplay.map((schedule) => (
              <ListGroupItem
                key={schedule.uuid}
                onClick={() =>
                  this.displayDeleteConfirm(
                    this.props.events[schedule.prodIndex],
                    this.props.events[schedule.reasonIndex],
                  )
                }
                header={new Date(schedule.actionTime).toLocaleString('en-US', {
                  hour12: false,
                })}
              >
                {schedule.change}
              </ListGroupItem>
            ))}
          </ListGroup>
        )}

        {schedulesToDisplay.length === 0 && (
          <ListGroup>
            <ListGroupItem href="#NoItems" header="No Scheduled Changes" />
          </ListGroup>
        )}
      </div>
    );
  }
}
